import { Modal } from 'react-bootstrap'
import SelectBox from 'devextreme-react/select-box'
import { DateBox } from 'devextreme-react'
import { Form } from 'react-bootstrap'
import { useEffect, useState } from 'react'
import { useCrm } from '../../../Providers/CrmProvider'
import { toast } from 'react-toastify'

/**
 * DK : Modal do dodawania i edycji zdarzenia CRM
 * @param {object} crmEvent - Zdarzenie do edycji - tryb edycji 
 * @param {func} setCrmEvents - Funkcja do aktualizacji zdarzen crm
 * @returns true - jeżeli poprawnie dodano zdarzenie
 */
const AddEditCrmTaskModal = ({ show, onHide, type, userName, crmEvent, setCrmEvents }) => {
    const { crmEventTypes, handleCreateCRMEvent, handleEditCrmEvent } = useCrm()

    const handleSetInitialTopic = () => {
        if (type == 'Telefon') {
            return `Rozmowa telefoniczna z ${userName}`
        }
        else if (type == 'Wizyta') {
            return 'Wizyta'
        }
        return ''
    }

    const handleSetInitialNote = () => {
        if (type == 'Telefon') {
            return `Rozmowa telefoniczna z ${userName}`
        }
        else if (type == 'Wizyta') {
            return `Spotkanie z ${userName}`
        }
        return ''
    }

    const findInitialEvent = () => {
        if (!crmEventTypes || crmEventTypes.length === 0) {
            return null
        }

        if (type === 'Telefon') {
            return crmEventTypes.find(e => e.toLowerCase().includes('telefon')) || null
        }
        if (type === 'Wizyta') {
            return crmEventTypes.find(e => e.toLowerCase().includes('wizyta')) || null
        }
        return null
    }

    const setInitialState = () => {
        if (crmEvent) {
            return {
                event: crmEvent.type,
                date: new Date(crmEvent.eventDateTime),
                topic: crmEvent.theme,
                grade: crmEvent.evaluation,
                note: crmEvent.comments,
            }
        }
        else {
            return {
                event: findInitialEvent(),
                date: new Date(),
                topic: handleSetInitialTopic(),
                grade: '',
                note: handleSetInitialNote(),
            }
        }
    }

    const [crm, setCrm] = useState(setInitialState())
    const [errorMessage, setErrorMessage] = useState(null)

    useEffect(() => {
        if (show) {
            setCrm(setInitialState())
            setErrorMessage(null)
        }
    }, [show])

    const handleInputOnChange = (e) => {
        const { name, value } = e.target
        setCrm(prev => ({
            ...prev,
            [name]: value
        }))
    }

    const handleDevExChange = (name, value) => {
        setCrm(prev => ({
            ...prev,
            [name]: value
        }))
    }

    const validateData = () => {
        if (!crm.event) {
            setErrorMessage('Zdarzenie nie może byc puste!')
            return false
        }
        if (!crm.topic || crm.topic.trim() == '') {
            setErrorMessage('Temat nie może byc pusty!')
            return false
        }
        return true
    }

    const handleSaveCrmEvent = async () => {
        if (validateData()) {
            let res = null
            if (crmEvent) {
                res = await handleEditCrmEvent(crmEvent.recno, crm.event, crm.topic, crm.date, crm.grade, crm.note, crmEvent.name)
            }
            else {
                res = await handleCreateCRMEvent(crm)
            }

            if (res) {
                let toastText = crmEvent ? 'Pomyślnie zmieniono zdarzenie' : 'Pomyślnie dodano zdarzenie'
                if (crmEvent) {
                    setCrmEvents(prev => prev.map(event =>
                        event.recno === crmEvent.recno
                            ? {
                                ...event,
                                type: crm.event,
                                theme: crm.topic,
                                eventDateTime: new Date(crm.date).toISOString(),
                                evaluation: crm.grade,
                                comments: crm.note,
                            }
                            : event
                    ))
                }
                toast.success(toastText)
                onHide(true)
            }
            else {
                let toastText = crmEvent ? 'Błąd w trakcie edycji zdarzenia' : 'Błąd w trakcie dodawania zdarzenia'
                toast.error(toastText)
            }
        }
    }

    let headerText = crmEvent ? 'Edycja zdarzenia' : `Nowe zdarzenie: ${type}`

    return (
        <Modal size='lg' show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>{headerText}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-2"><span>Zdarzenie:</span></div>
                    <div className="col-10">
                        <SelectBox
                            dataSource={crmEventTypes}
                            placeholder='Wybierz typ zdarzenia'
                            value={crm.event}
                            onValueChanged={(e) => handleDevExChange('event', e.value)}
                            searchEnabled={true}
                            searchMode="contains"
                        />
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-2"><span className='mt-2'>Data:</span></div>
                    <div className="col-10">
                        <DateBox
                            value={crm.date}
                            displayFormat="yyyy-MM-dd"
                            type='date'
                            onValueChanged={(e) => handleDevExChange('date', e.value)}
                        />
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-2"><span className='mt-2'>Temat:</span></div>
                    <div className="col-10">
                        <Form.Control
                            name='topic'
                            maxLength={100}
                            value={crm.topic}
                            onChange={handleInputOnChange}
                        />
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-2"><span className='mt-2'>Ocena:</span></div>
                    <div className="col-10">
                        <Form.Control
                            name='grade'
                            value={crm.grade}
                            maxLength={8}
                            onChange={handleInputOnChange}
                        />
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-2"><span className='mt-2'>Uwagi:</span></div>
                    <div className="col-10">
                        <Form.Control
                            as="textarea"
                            name='note'
                            value={crm.note}
                            onChange={handleInputOnChange}
                        />
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col d-flex align-items-center justify-content-center">
                        <b className='error-text-color'>{errorMessage}</b>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className='btn-app-primary' onClick={handleSaveCrmEvent}>Zapisz</button>
                <button className='btn-app-secondary' onClick={() => onHide(false)}>Anuluj</button>
            </Modal.Footer>
        </Modal>
    )
}

export default AddEditCrmTaskModal